import React, { useState } from 'react';
import { Card, Tabs, Avatar } from '@opendate-app/setlist';

export default function TopContactsCard({ topContacts, contactLabel }) {
  const [rank, setRank] = useState('value');
  const rows = rank === 'value' ? topContacts.by_value : topContacts.by_visits;

  return (
    <Card padding="md">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <h2 style={{ margin: 0, fontSize: 18 }}>Top {contactLabel.toLowerCase()}</h2>
        <Tabs
          variant="button-border"
          size="sm"
          collapseBelow={0}
          aria-label="Rank by"
          value={rank}
          onChange={setRank}
          items={[{ value: 'value', label: 'Value' }, { value: 'visits', label: 'Visits' }]}
        />
      </div>
      {rows.map((p) => (
        <a key={p.id} href={p.url} className="text-reset text-decoration-none" style={{ display: 'flex', gap: 12, padding: '10px 0', alignItems: 'center' }}>
          <Avatar size="sm" initials={p.initials} alt={p.name} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600 }}>{p.name}</div>
            <div style={{ fontSize: 12, color: 'var(--sl-text-quaternary, #717680)' }}>{p.email}</div>
          </div>
          <div style={{ fontWeight: 700 }}>
            {rank === 'value' ? `$${Math.round(p.lifetime_value).toLocaleString()}` : p.events}
          </div>
        </a>
      ))}
    </Card>
  );
}
